import React from 'react';
import {Card, CardContent, Typography} from "@material-ui/core";

const AboutUsInfo2 = () => {
  return (
    <Card elevation={4}>
      <CardContent>
        <div>
          <Typography variant="h4" component="span">My mother’s dream </Typography>
          <Typography variant="body1" component="span">
            and inspiration of becoming a cook and owning her own restaurant
            continued to blossom as the years passed. Unfortunately, she has also experienced great loss over
            the years, but she never let her dream falter. She feels the same burning inspiration after all these
            years. Being her eldest daughter and her always being one of my biggest supporters in obtaining
            both of my nursing degrees, my husband and I felt the calling to make my mother’s dream come
            true. My mother has always been very loving and selfless. She would give you the shirt off her
            very back and the last few dollars in her wallet before letting others go without. It is because of
            her that I was able to achieve my most recent degree. I successfully completed my bachelor’s
            degree in the science of nursing at Goshen College. She never gave up on me and supported my
            dream, my husband, and my children 100% of the way. When I felt overwhelmed and at times
            utter defeat, she reminded me to never give up on my dreams and to always strive for the best.
            She has taught me that the things worth most in life come with hard work and sacrifice.
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
};

export default AboutUsInfo2;
